import React, { useEffect, useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import AOS from "aos";
import axios from "axios";
import DeleteButton from "../tools/DeleteButton"
import AddButton from "../tools/AddButton"

function Statistics() {
  const { translations } = useLanguage();
  const [activeTab, setActiveTab] = useState("tab1");
  const [results, setResults] = useState([]);
  const [adminUsername, setAdminUsername] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get("https://artofbetting.gr/api/results");
        setResults(response.data.reverse());
      } catch (error) {
        console.error("Error fetching results:", error);
      }
    };

    const fetchAdminStatus = async () => {
      if (!token) {
        return;
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/get_admin_status", {
          headers: {
            "Authorization": token,
          }
        });
        if (response.data.admin_status) {
          setAdminUsername(response.data.admin_username);
        }
      } catch (error) {
        console.error("Error fetching admin status:", error);
      }
    };

    fetchResults();
    fetchAdminStatus();
  }, [token]);

  const deleteResult = async (id) => {
    try {
      await axios.post(`https://artofbetting.gr/api/delete_result/${id}`,
        {},
        {
          headers: {
            "Authorization": token,
          }
        }
      );

      // Ενημέρωση των αποτελεσμάτων μετά τη διαγραφή
      setResults(results.filter((result) => result.id !== id));

    } catch (error) {
      console.error("Error deleting result:", error);
      alert("Κάτι πήγε στραβά, δοκίμασε πάλι!");
    }
  };


  // Χειρισμός διαγραφής με επιβεβαίωση
  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Θέλετε σίγουρα να διαγράψετε αυτό το αποτέλεσμα;");
    if (confirmDelete) {
      deleteResult(id);
    }
  };

  const tipsters = {
    tab1: "mrarber",
    tab2: "vretanos",
    tab3: "nole",
  };

  const filteredResults = results.filter(
    (result) => result.tipster.toLowerCase() === tipsters[activeTab]
  ).sort((a, b) => new Date(b.date) - new Date(a.date));

  const isTheTipster = () => {
    return (
      (activeTab === "tab1" && adminUsername === "Cucci39") ||
      (activeTab === "tab2" && adminUsername === "billy10") ||
      (activeTab === "tab3" && adminUsername === "DarleyDar")
    );
  };

  // Συνάρτηση για τον υπολογισμό στατιστικών
  const calculateStatistics = (results) => {
    const totalWon = results.filter((result) => result.won).length;
    const totalLost = results.filter((result) => !result.won).length;
    const totalUnits = results.reduce((sum, result) => sum + result.units, 0);
    const totalReturns = results.reduce((sum, result) => {
      return result.won ? sum + result.units * result.odds : sum;
    }, 0);
    const totalProfit = totalReturns - totalUnits;
    const roiPercentage = ((totalProfit / totalUnits) * 100).toFixed(2);

    return {
      totalWon,
      totalLost,
      totalUnits,
      totalReturns,
      totalProfit,
      roiPercentage,
    };
  };

  // Στατιστικά για όλο το χρονικό διάστημα
  const overallStats = calculateStatistics(filteredResults);

  // Φιλτράρισμα αποτελεσμάτων για τον τελευταίο μήνα
  const currentMonthResults = filteredResults.filter((result) => {
    const resultDate = new Date(result.date);
    const currentDate = new Date();

    // Πάρε την πρώτη μέρα του τρέχοντος μήνα
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    // Έλεγξε αν η ημερομηνία του αποτελέσματος είναι μετά ή ίση με την πρώτη μέρα του τρέχοντος μήνα
    return resultDate >= firstDayOfMonth;
  });

  // Στατιστικά για τον τελευταίο μήνα
  const lastMonthStats = calculateStatistics(currentMonthResults);

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4 w-full max-w-screen overflow-x-hidden">
      {/* Header */}
      <header className="flex justify-between items-center p-4 bg-gray-800 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      <h2 className="text-3xl font-bold mb-4 mt-6">{translations.statisticsToday}</h2>

      {/* Tab Buttons */}
      <div className="grid grid-cols-3 gap-4 mt-6">
        <button
          onClick={() => setActiveTab("tab1")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab1" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.mrArber}
        </button>
        <button
          onClick={() => setActiveTab("tab2")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab2" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.vretanos}
        </button>
        <button
          onClick={() => setActiveTab("tab3")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab3" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.nole}
        </button>
      </div>

      {/* Στατιστικά Συνολικά Χρόνου */}
      <div className="mt-6 bg-gray-800 p-4 rounded-lg">
        <h2 className="text-xl font-bold mb-4">{translations.totalYear}</h2>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 text-center">
          <div>
            <p className="text-gray-400 text-xs">{translations.totalWon}</p>
            <p>{overallStats.totalWon}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalLost}</p>
            <p>{overallStats.totalLost}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalUnits}</p>
            <p>{overallStats.totalUnits.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalReturns}</p>
            <p>{overallStats.totalReturns.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.profitTotal}</p>
            <p
              className={`${
                overallStats.totalProfit < 0 ? "text-red-500" : "text-green-500"
              }`}
            >
              {`${overallStats.totalProfit.toFixed(2)}`}
            </p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.profitPercent}</p>
            <p
              className={`${
                parseFloat(overallStats.roiPercentage) < 0 ? "text-red-500" : "text-green-500"
              }`}
            >
              {`${overallStats.roiPercentage !== "NaN" ? overallStats.roiPercentage : "0"}%`}
            </p>
          </div>
        </div>
      </div>

      {/* Στατιστικά Συνολικά Μήνα */}
      <div className="mt-6 bg-gray-800 p-4 rounded-lg">
        <h2 className="text-xl font-bold mb-4">{translations.totalMonth}</h2>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 text-center">
          <div>
            <p className="text-gray-400 text-xs">{translations.totalWon}</p>
            <p>{lastMonthStats.totalWon}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalLost}</p>
            <p>{lastMonthStats.totalLost}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalUnits}</p>
            <p>{lastMonthStats.totalUnits.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.totalReturns}</p>
            <p>{lastMonthStats.totalReturns.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.profitTotal}</p>
            <p
              className={`${
                lastMonthStats.totalProfit < 0 ? "text-red-500" : "text-green-500"
              }`}
            >
              {`${lastMonthStats.totalProfit.toFixed(2)}`}
            </p>
          </div>
          <div>
            <p className="text-gray-400 text-xs">{translations.profitPercent}</p>
            <p
              className={`${
                parseFloat(lastMonthStats.roiPercentage) < 0 ? "text-red-500" : "text-green-500"
              }`}
            >
              {`${lastMonthStats.roiPercentage !== "NaN" ? lastMonthStats.roiPercentage : "0"}%`}
            </p>
          </div>
        </div>
      </div>

      {/* Results */}
      <main className="mt-6">
        <div className="flex w-full gap-4 mb-4">
          <h2 className="text-xl font-bold">{translations.results}</h2>
          { isTheTipster() &&
            <Link to="/new_result">
              <AddButton/>
            </Link>
          }
        </div>
        {filteredResults.length > 0 ? (
          filteredResults.map((result) => {
            const profit = result.won ? ((result.units * result.odds) - result.units).toFixed(2) : (result.units).toFixed(2);
            const profitClass = result.won ? "bg-green-700" : "bg-red-700";

            return (
              <div
                key={result.id}
                className="bg-gray-800 p-4 rounded-lg shadow-lg mb-4"
                data-aos="fade-up"
              >
                {/* Match & Date */}
                <div className="flex justify-between items-center mb-4">
                  { isTheTipster() && <DeleteButton onClick={() => handleDelete(result.id)} /> }
                  <h3 className="text-xl font-semibold ml-2 mr-2">{result.match}</h3>
                  <p className="text-sm text-gray-400 text-center">{new Date(result.date).toLocaleDateString("el-GR")} {result.time}</p>
                </div>

                {/* Prediction & Odds */}
                <div className="grid grid-cols-[25%_18%_12%_25%_20%]">
                  <div>
                    <p className="text-gray-400 text-xs text-center">{translations.prediction}</p>
                    <p className="text-center">{result.prediction}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs text-center">{translations.odds}</p>
                    <p className="text-center">{result.odds}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs text-center">{translations.units}</p>
                    <p className="text-center">{result.units}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs text-center">{translations.result}</p>
                    <p className="text-center">
                      {result.resultHome} - {result.resultAway}
                    </p>
                  </div>
                  <button
                    className={`w-full h-10 rounded text-white font-bold ${profitClass}`}
                  >
                    {result.won ? `+${profit}` : `-${profit}`}
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-center text-gray-400">{translations.noResults}</p>
        )}
      </main>

      {/* Footer */}
      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Statistics;